var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpressionsmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.25a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5Zm0-5.37a2.13 2.13 0 1 0 0 4.25 2.13 2.13 0 0 0 0-4.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.77c-2.82 0-5.48-1.65-7.31-4.52a4.54 4.54 0 0 1 0-4.5C3.52 3.89 6.19 2.24 9 2.24c2.81 0 5.47 1.65 7.3 4.51.8 1.24.8 3.26 0 4.5-1.83 2.87-4.49 4.52-7.3 4.52ZM9 3.36c-2.42 0-4.74 1.46-6.36 4a3.4 3.4 0 0 0 0 3.28c1.62 2.55 3.94 4 6.36 4 2.42 0 4.74-1.45 6.36-4a3.4 3.4 0 0 0 0-3.28c-1.62-2.54-3.94-4-6.36-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressionsmedium);
export default __webpack_public_path__ + "static/media/impressions.medium.76953e0726f5800f0d77853a99184cfb.svg";
export { ForwardRef as ReactComponent };